import { useCallback, useEffect, useRef } from 'react';
import { sleep } from '@sas/nova-core/util';
import { useMounted } from '../../../hooks/useMounted';
import { getFirstFocusable } from '../../../util/focus';
const useHandleDialogOpenState = ({
  onOpen,
  onClose,
  isOpen
}) => {
  const {
    current: isMounted
  } = useMounted();
  const dialogRef = useRef(null);
  const shouldRunFunctions = useRef({
    onOpen: true,
    onClose: false
  });
  const handleInitialFocus = useCallback(() => {
    if (dialogRef.current) {
      const autoFocusableAreas = dialogRef.current.querySelectorAll('*[data-autofocus-inside="true"]');
      for (const area of autoFocusableAreas) {
        const focusableElement = getFirstFocusable(area);
        if (focusableElement) {
          focusableElement.focus();
          break;
        }
      }
    }
  }, []);
  const onModalOpen = useCallback(async () => {
    await sleep(0);
    if (!isMounted) return;
    handleInitialFocus();
    onOpen?.();
  }, [onOpen, handleInitialFocus, isMounted]);
  const onModalClose = useCallback(async () => {
    if (!isMounted) return;
    onClose?.();
  }, [onClose, isMounted]);

  // Handle when to call open functions
  useEffect(() => {
    if (isOpen && shouldRunFunctions.current.onOpen) {
      onModalOpen();
      shouldRunFunctions.current.onOpen = false;
    }
    if (!isOpen) {
      shouldRunFunctions.current.onOpen = true;
    }
  }, [onModalOpen, isOpen]);

  // Handle when to call close functions
  useEffect(() => {
    if (!isOpen && shouldRunFunctions.current.onClose) {
      onModalClose();
      shouldRunFunctions.current.onClose = false;
    }
    if (isOpen) {
      shouldRunFunctions.current.onClose = true;
    }
  }, [isOpen, onModalClose]);
  return {
    dialogRef
  };
};
export default useHandleDialogOpenState;
//# sourceMappingURL=useHandleDialogOpenState.js.map